export const AMPLITUDE_API_KEY = '31e31b857ff7ab2051dc75c823b8512c'
export const COUNTRY = 'tg'
